<template>
  <div v-if="errors.length" class="errors-list">
    <h4 v-if="title" class="global-h4 errors-list__title">{{ title }}</h4>
    <ul class="errors-list__list-itself">
      <li class="errors-list__li" v-for="error in errors" :key="error">- {{ error }}</li>
    </ul>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title?: string;
  errors: string[];
}>();
</script>

<style scoped lang="scss">
.errors-list {
  margin-top: 1rem;
  color: firebrick;

  &__title {
    margin-bottom: 8px;
    color: firebrick;
  }

  &__list-itself {
    padding: 0;
    margin: 0 0 20px;
    list-style: none;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__li {
    font: 14px/18px sans-serif;
  }
}
</style>
